/**
 * paymentToggles.ts - Payment method radio handling, showing/hiding the
 * Stripe payment panel, and keeping the mounted Payment Element in sync
 * with the selected method.
 */
import { state } from './config';
import { initStripePayment, teardownStripePayment } from './stripePayment';

export function initPaymentToggles(): void {
    document.querySelectorAll<HTMLInputElement>('.js-payment-toggle').forEach(radio => {
        radio.addEventListener('change', (e: Event) => {
            const target = e.target as HTMLInputElement;
            state.paymentMethod = target.value;
            void toggleCreditCardPanel(state.paymentMethod);
        });
    });
}

export async function toggleCreditCardPanel(method: string): Promise<void> {
    const ccPanel = document.getElementById('CreditCardPanel');
    if (!ccPanel) return;

    if (method === 'Online') {
        ccPanel.classList.remove('d-none');
        await initStripePayment();
    } else {
        ccPanel.classList.add('d-none');
        teardownStripePayment();
    }
}

/**
 * Called whenever step 3 is (re)entered - e.g. after the user goes back
 * and changes players or the donation amount - so the PaymentIntent
 * amount and mounted Element stay in sync with the current cart.
 */
export async function syncPaymentPanelForStep3(): Promise<void> {
    await toggleCreditCardPanel(state.paymentMethod);
}